import { get, put, post, deleteRequest } from 'helpers/api';

export const fetchShowcaseContactGroups = ({ projectId }) => {
  return get(`/projects/${projectId}/showcase_contact_groups`);
};

export const createProjectContactGroup = ({ projectId, name }) => {
  return post(`/projects/${projectId}/showcase_contact_groups`, { showcaseContactGroup: { name } });
};

export const updateProjectContactGroup = ({ projectId, groupId, showcaseContactGroup }) => {
  return put(`/projects/${projectId}/showcase_contact_groups/${groupId}`, { showcaseContactGroup });
};

export const deleteProjectContactGroup = ({ projectId, groupId }) => {
  return deleteRequest(`/projects/${projectId}/showcase_contact_groups/${groupId}`);
};

export const fetchShowcaseContacts = (params = {}) => {
  return get('/showcase_contacts', { params });
};

export const addContactToProject = ({ contactId, groupId, projectId }) => {
  return post(`/projects/${projectId}/showcase_contacts`, { contactId, groupId });
};

export const createShowcaseContact = (showcaseContact) => {
  return post('/showcase_contacts', { showcaseContact });
};

export const removeContactFromProject = ({ projectId, projectContactId }) => {
  return deleteRequest(`/projects/${projectId}/showcase_contacts/${projectContactId}`);
};

export const deleteShowcaseContact = (contactId) => {
  return deleteRequest(`/showcase_contacts/${contactId}`);
};

export const assignGroup = ({ contactId, projectId, groupLabel }) => {
  return post(`/showcase_contacts/${contactId}/assign_group`, { projectId, groupLabel });
};
